export const colors = {
  blue: "#40a9ff",
};

export const LDX_COLOR_ORANGE = "rgba(246, 137, 28, 1)";
export const LDX_COLOR_GREY = "rgba(60, 66, 72, 1)";
